var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsPlace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3604 3.00879C16.0589 3.19633 19 6.25486 19 10C19 10.0326 18.9975 10.0651 18.9971 10.0977C18.9975 10.1317 19 10.166 19 10.2002C19 10.4578 18.9732 10.727 18.9258 11.0059C18.8044 11.8489 18.5345 12.6434 18.1406 13.3613C16.4454 17.015 12.7641 21 12 21C11.2359 21 7.55357 17.0151 5.8584 13.3613C5.46466 12.6434 5.19457 11.8488 5.07324 11.0059C5.02589 10.7271 5.00001 10.4577 5 10.2002C5 10.166 5.00149 10.1317 5.00195 10.0977C5.00151 10.0652 5 10.0326 5 10C5 6.25486 7.94111 3.19633 11.6396 3.00879C11.759 3.00256 11.8792 3 12 3C12.1208 3 12.241 3.00256 12.3604 3.00879ZM12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8Z",
    fill: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPlace);
export default __webpack_public_path__ + "static/media/icons-place.a8300575c81ac2a224158d25d2342bc3.svg";
export { ForwardRef as ReactComponent };